module.exports = __webpack_public_path__ + "img/Serbia.237fb4e5.gif";